class HtmlHelper {
    static getById(id) {
        const element = document.getElementById(id);
        if (!element) {
            throw new Error(`Element with id ${id} not found`);
        }
        return element;
    }

    static select(selector) {
        const element = document.querySelector(selector);
        if (!element) {
            throw new Error(`Element with selector ${selector} not found`);
        }
        return element;
    }
}

export default HtmlHelper;